// extracted by mini-css-extract-plugin
module.exports = {"Menu-container":"Menu_Menu-container__24crY"};